jQuery(".hero-slider__wrapper")
    .on('init', function(event, slick) {
        color = slick.$slides[0].dataset['color'];

        jQuery('section#header').css('background-color', color);
        return;
    })
    .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        color = slick.$slides[nextSlide].dataset['color'];

        jQuery('section#header').css('background-color', color);
        return;
    });

// Hero Slider

if(jQuery(".hero-slider__wrapper").length) {
    jQuery(".hero-slider__bg").slick();
    jQuery(".hero-slider__wrapper").slick({
        asNavFor: '.hero-slider__bg',
        infinite: true,
        swipe: true,
        dots: true,
        dotsClass: 'slick-dots hero-slider__dots',
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5500,
        pauseOnFocus: false,
        pauseOnHover: false,
        prevArrow: '<button class="hero-slider__arrow hero-slider__arrow--prev"><i></i></button>',
        nextArrow: '<button class="hero-slider__arrow hero-slider__arrow--next"><i></i></button>',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    arrows: false
                }
            },
        ]
    });
}

if(jQuery(".hero--product-slider").length) {
    jQuery(".hero--product-slider").slick({
        infinite: true,
            swipe: true,
            dots: true,
            dotsClass: 'slick-dots hero-slider__dots',
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnFocus: false,
            pauseOnHover: false,
            speed: 1,
        }
    );
}

if(jQuery(".recipe-slider").length) {
    jQuery(".recipe-slider").slick(
        {
            swipe: true,
            dots: true,
            dotsClass: 'slick-dots recipe-slider__dots',
            arrows: false,
            autoplay: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            speed: 1000,
            variableWidth: true,
            // centerMode: true,
            // centerPadding: '0',
        }
    );
}

if(jQuery(".hero-slider__wrapper").length) {
    jQuery(".hero-slider__bg").slick();
    jQuery(".hero-slider__wrapper").slick({
        asNavFor: '.hero-slider__bg',
        slidesToShow:7,
        infinite: true,
        swipe: true,
        dots: true,
        dotsClass: 'slick-dots hero-slider__dots',
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000000,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 1,
        prevArrow: '<button class="hero-slider__arrow hero-slider__arrow--prev"><i></i></button>',
        nextArrow: '<button class="hero-slider__arrow hero-slider__arrow--next"><i></i></button>',
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    arrows: false,
                    slidesToShow:4,

                }
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    slidesToShow:1,

                }
            },
        ]
    });
}
